import { useNavigate } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { Button } from '../../components/ui/button';

export function NotFoundPage() {
	const navigate = useNavigate();

	return (
		<div className="flex flex-1 flex-col items-center justify-center gap-5 py-20">
			<div className="grid h-14 w-14 place-items-center rounded-full border border-line-1 bg-surface-fill">
				<MapPin className="h-6 w-6 text-text-3" />
			</div>
			<div className="text-center">
				<p className="text-xs font-medium uppercase tracking-[0.08em] text-text-4">
					Error 404
				</p>
				<h1 className="mt-2 text-xl font-medium -tracking-[0.01em] text-text-1">
					Page not found
				</h1>
				<p className="mt-1.5 max-w-sm text-base leading-relaxed text-text-3">
					The link may be outdated, or the page has moved. Check the address, or head back
					to your dashboard.
				</p>
			</div>
			<Button onClick={() => navigate('/')}>
				Back to dashboard
				<ArrowRight className="h-3.5 w-3.5" data-icon="inline-end" />
			</Button>
		</div>
	);
}
